import { NgModule, ModuleWithProviders } from '@angular/core';
import { OktaWidgetComponent } from './okta-widget.component';
import { LoginPageComponent } from './login-page.component';
import { AuthenticationState } from './authentication-state';
import { LogoutPageComponent } from './logout-page.component';
import { UserAuthenticatedGuard } from './user-authenticated-guard';
import { SharedModule } from '../shared/shared.module';
import { IdleUserMonitor } from './idle-user-monitor';
import { TimeoutWarningComponent } from './timeout-warning.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        OktaWidgetComponent,
        LoginPageComponent,
        LogoutPageComponent,
        TimeoutWarningComponent
    ],
    entryComponents: [
        TimeoutWarningComponent
    ],
    exports: [
        LoginPageComponent,
        LogoutPageComponent,
    ]
})
export class AuthenticationModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: AuthenticationModule,
            providers: [
                AuthenticationState,
                UserAuthenticatedGuard,
                IdleUserMonitor
            ]
        };
    }
}